import { TestDisplayProperties } from "@lib/js-slingo-pawnshop-core/dist";
import { GridLayout } from "@lib/titan2/dist/game/control/layout/GridLayout";
import * as PIXI from "pixi.js";
/**
 * TestDisplayLandscapeProperties.ts
 */
export class TestDisplayLandscapeProperties extends TestDisplayProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.testButtonProperties.textFieldProperties.size = new PIXI.Point(150, 30);
        this.panelProperties.layout = new GridLayout(99, 8, 5, 5);
    }
}
